import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { VerificationComponent } from './pages/onboarding/verification/verification.component';

const routes: Routes = [
  {
    path: 'verification', component: VerificationComponent
  },
  {
    path:'',loadChildren :() => import('../app/pages/onboarding/onboarding.module').then(m => m.OnboardingModule), canActivate:[LoginGuard]
  },
  {
    path:'core', loadChildren :() => import('../app/pages/core/core.module').then(m => m.CoreModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
  providers: [LoginGuard]
})
export class AppRoutingModule { }
